module.exports = __webpack_public_path__ + "img/yc-logo.598b6593.png";